<template>
  <ul :class="classes">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      return [
        'ewr-radio-group',
        {
          'ewr-radio-group--inline': this.inline
        }
      ]
    }
  }
}
</script>

<style lang="scss">
$border_color: $gray300;

.form__field ul.ewr-radio-group {
  margin: 0px;
}

.ewr-radio-group {
  @include list-reset;
  margin-left: blh(0.5);

  // li label.error {
  //   @include margin(-20px null null -25px);
  // }

  &--inline {
    li {
      display: inline-block;
      margin-right: blh(1);
      padding-top: blh(-1);

      label {
        padding: 0px;

        input {
          margin-left: 1px;
        }
      }
    }
  }
}

.ewr-form-field--infield-top-aligned {
  .ewr-radio-group {
    background-color: white;
    margin-left: 0;
    padding-top: blh(1);
    padding-left: 10px;
    min-height: blh(2.5);
    // border: none;
    // box-shadow: 0px 0px 0px 1px $border_color;
    border: 1px solid $gray300;

    li {
      input[type='radio']:checked ~ span {
        font-weight: 600;
      }

      label {
        padding: 0px;
        line-height: blh(1.25);
      }

      label.error {
        color: #c00;
        font-size: type-scale(-2);
        margin-left: 0px;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
</style>
